import React from 'react'

import {Breadcrumb, Layout, Modal, message, Spin, Row, Col, Menu, Icon} from 'antd'
import {Divider} from 'antd'
import SplitterLayout from 'react-splitter-layout'
import 'react-splitter-layout/lib/index.css'
import './photos.css'
import _ from 'lodash'
import Map from './Map'
import Settings from '../commons/StatelessSettings'
import SettingsHandler from '../commons/SettingsHandler'
import ModalCarousel from './ModalCarousel'
import photoService from '../services/photo.service'
import fileUploadService from '../services/file.upload.service'
import fileDownloadService from '../services/file.download.service'
import authService from '../services/authentication.service'
import userService from '../services/users.service'
import * as constants from '../commons/constants'
import {findFolder, getFolderPath, isAncestor} from '../utils/functions'
import GenericModal from '../commons/GenericModal'
import SmallPhoto from './SmallPhoto'
import FolderTree from '../commons/FolderTree'
import {comparator} from '../utils/functions'
import searchHandler from '../commons/SearchHandler'
import Toolbar from '../commons/Toolbar'
import {Input} from "antd/lib/index";

const {Content, Sider} = Layout
const {confirm} = Modal
const {Search} = Input



class PhotosView extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            collapsed: true,
            loadingTree: true,
            treeData: [],
            selectedFolder: {
                _id: null,
            },
            modal: {
                visible: false,
                action: null,
                data: [],
            },
            photos: [],
            folderPath: 'Photos',
            expandedKeys: [],
            mapOn: false,
            selectedPhotos: [],
            users: [],
            carouselVisible: false,
            settings: {
                users: []
            }
        }
        this.upload = null
        this.ctrlKey = false
        this.selectedFolderName = ''
        this.currentTreeAction = ''
        this.smallPhotos = {}
        this.map = {}
        this.settingsHandler = new SettingsHandler(this, photoService);
        this.user = authService.getAuthenticatedUser()
    }

    getFirstSelectedFile = () => {
        return !_.isEmpty(this.state.selectedPhotos)
            ? this.state.selectedPhotos[0].props.file
            : undefined
    }

    getSelectedPhotoIndex = () => {
        if (this.state.selectedPhotos.length == 1) {
            const selected = this.state.selectedPhotos[0].props.file
            return _.findIndex(this.state.photos, p => p._id == selected._id)
        }
        return 0
    }

    handleOnClickMenu = ({item, key, keyPath, domEvent}) => {
        domEvent.preventDefault()
        domEvent.stopPropagation()
        console.log('handleOnClickMenu:', item, key)
        this.currentTreeAction = key
        if (key === constants.UPLOAD_FILES) {
            this.upload.click()
        }

        if (key === constants.ADD_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: '',
                },
            })
        }

        if (key === constants.RENAME_FOLDER) {
            this.setState({
                modal: {
                    visible: true,
                    action: key,
                    data: this.selectedFolderName,
                },
            })
        }

        if (key == constants.CUT_FOLDER) {
            this.cutFolderId = this.state.selectedFolder._id;
        }

        if (key == constants.PASTE_FOLDER) {

            this.moveFolder(this.cutFolderId, this.state.selectedFolder._id)
            this.cutFolderId = null;
        }

        if (key == constants.DELETE_FOLDER) {
            this.deleteFolder(this.state.selectedFolder)
        }
    }

    handleModalOk = async data => {
        console.log(data)

        if (this.currentTreeAction === constants.ADD_FOLDER) {
            //passing iconCls to keep backward compatibility
            const folder = {
                text: data,
                iconCls: 'icon-folder-open',
                _parentId: this.state.selectedFolder._id,
            }

            const savedFolder = await photoService.saveFolder(
                folder,
                this.state.folderPath
            )

            if (!this.state.selectedFolder.children) {
                this.state.selectedFolder.children = []
            }
            this.state.selectedFolder.children.push(savedFolder)
            this.state.selectedFolder.children.sort(comparator);

            this.state.expandedKeys.push(savedFolder._id)
            console.log('expandedKey:', this.state.expandedKeys)
            this.setState({
                treeData: this.state.treeData,
                selectedFolder: savedFolder,
                expandedKeys: this.state.expandedKeys,
            })
        }

        if (this.currentTreeAction === constants.RENAME_FOLDER) {
            const folder = this.state.selectedFolder
            folder.text = data;
            const savedFolder = await photoService.saveFolder(
                folder,
                this.state.folderPath
            )
            const parentFolder = findFolder(folder._parentId, this.state.treeData);
            parentFolder.children.sort(comparator);
            this.setState({treeData: this.state.treeData})
        }
        this.closeModal()
    }

    closeModal = () => {
        this.setState({modal: {visible: false, data: {}}})
    }

    setUploadProgress = (filename, percent, status) => {
        const data = this.state.modal.data
        data[filename] = {name: filename, percent: percent, status: status}
        this.setState({
            modal: {visible: true, action: constants.UPLOAD_FILES, data: data},
        })
    }

    handleOnUploadProgress = (filename, percent) => {
        console.log('handleOnUploadProgress', filename, percent)
        this.setUploadProgress(filename, percent, 'active')
    }

    handleOnChangeFile = event => {
        event.stopPropagation()
        event.preventDefault()
        const files = event.target.files
        const folderId = this.state.selectedFolder._id
        let data = {}
        for (let file of files) {
            data[file.name] = {name: file.name, percent: 0, status: 'active'}
            fileUploadService
                .sendFile(file, {
                    name: 'documents',
                    params: {
                        folderId: folderId,
                        folderPath: getFolderPath(this.state.treeData, folderId),
                    },
                    onProgress: this.handleOnUploadProgress,
                    url: '/api/v1/photos/upload',
                })
                .then(file => {
                    console.log('file uploaded successfully', file)
                    this.setUploadProgress(file.originalname, 100, 'success')
                    this.setState({photos: [...this.state.photos, file]})
                })
                .catch(error => {
                    console.log('error uploading file', error)
                    this.setUploadProgress(error.filename, 100, 'exception')
                })
        }
        this.setState({modal: {visible: true, action: 'upload', data: data}})
    }

    removeHighlight = () => {
        this.state.selectedPhotos.forEach(c => c.setHighlight(false))
        this.state.selectedPhotos = []
    }

    handleOnSelectPhoto = component => {
        if (!this.ctrlKey) {
            this.removeHighlight()
        }
        component.setHighlight(true);

        this.state.selectedPhotos.push(component);

        this.setState({selectedPhotos: this.state.selectedPhotos});

        this.updateSettings(this.state.selectedFolder,
            component.props.file, this.state.settings.users);

        if (this.state.mapOn) {
            this.map.addMarkerAnimation(component.props.file._id)
        }
    }

    handleDownload = () => {
        if (this.state.selectedPhotos.length == 1) {
            const file = this.state.selectedPhotos[0].props.file
            const url = `/api/v1/photos/file/download/?fileId=${file._id}&folderPath=${this.state.folderPath}`
            window.open(url);
            //fileDownloadService.download(url, file.originalname)
        }
    }

    handleOnClickOnMapMarker = photoId => {
        const component = this.smallPhotos[photoId]
        this.handleOnSelectPhoto(component)
    }

    handleDelete = () => {
        confirm({
            title: 'Are you sure you want to delete these photos?',
            content: 'After clicking OK the photos will be deleted permanently',
            onOk: async () => {
                console.log('OK')
                for (let comp of this.state.selectedPhotos) {
                    await photoService.deletePhoto(comp.props.file._id)
                }
                const filtered = this.state.photos.filter(p => {
                    let found = false
                    for (let comp of this.state.selectedPhotos) {
                        if (comp.props.file._id == p._id) {
                            found = true
                            break
                        }
                    }
                    return !found
                })
                this.setState({photos: filtered})
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }


    handleLoadData = treeNode => {
        const folderId = treeNode.props.dataRef._id;
        console.log('handleLoadData: folderId=', folderId);
        return new Promise(resolve => {
            if (!_.isEmpty(treeNode.props.children)) {
                resolve();
                return;
            }
            photoService.getTreeData(folderId).then(data => {
                treeNode.props.dataRef.children = data;
                this.setState({
                    treeData: [...this.state.treeData]
                });
                resolve();
            }).catch(error => {
                console.error(error)
            });
        });
    }

    moveFiles = async (fileIds, folderId, dnd = true) => {
        console.log('moveFiles:', fileIds, folderId, dnd)
        const rsp = await photoService.moveFiles(fileIds, folderId)
        if (rsp.rspCode === 'ok') {
            if (dnd) {
                const filtered = _.filter(
                    this.state.photos,
                    p => !fileIds.includes(p._id)
                )
                this.setState({photos: filtered})
                this.removeHighlight()
            }
            else { //cut and paste
                const photos = await photoService.getPhotos(folderId)
                this.setState({photos: photos})
            }
            message.success('Files moved successfully')
        } else {
            message.error('Error occurred while moving files')
        }
        console.log('moveFiles:', rsp)
    }

    moveFolder = async (srcFolderId, targetFolderId) => {
        console.log('moveFolder:', srcFolderId, targetFolderId)

        if (isAncestor(srcFolderId, targetFolderId, this.state.treeData)) {
            message.error("Cannot move folder to one of its children...")
            return;
        }

        if (srcFolderId === targetFolderId) return;


        const rsp = await photoService.moveFolder(srcFolderId, targetFolderId)
        if (rsp.rspCode === 'ok') {
            /**  This logic needs to be optimized **/
            const srcFolder = findFolder(srcFolderId, this.state.treeData)
            const srcParent = findFolder(srcFolder._parentId, this.state.treeData)
            const targetFolder = findFolder(targetFolderId, this.state.treeData)
            srcFolder._parentId = targetFolder._id
            if (!targetFolder.children) targetFolder.children = []
            targetFolder.children.push(srcFolder)
            targetFolder.children.sort(comparator);
            _.remove(srcParent.children, child => {
                return child._id === srcFolder._id
            })
            this.setState({
                folderPath: getFolderPath(this.state.treeData, srcFolderId),
            })
            this.setState({treeData: this.state.treeData})
            message.success('Folder moved successfully')
        } else {
            message.error('Error occurred while moving folder')
        }
        console.log('moveFolder:', rsp)
    }

    deleteFolder = async (folder) => {
        const folderId = folder._id;
        confirm({
            title: 'Are you sure you want to delete this Folder?',
            content: 'After clicking OK folder will be deleted',
            onOk: async () => {
                const rsp = await photoService.deleteFolder(folderId)
                if (rsp.rspCode === "error") {
                    message.error(rsp.msg);
                }
                else {
                    const parent = findFolder(folder._parentId, this.state.treeData)
                    _.remove(parent.children, child => {
                        return child._id === folder._id
                    })
                    this.setState({treeData: this.state.treeData})
                    message.success('Folder delete successfully')
                }
            },
            onCancel() {
                console.log('Cancel')
            },
        })
    }

    showMap = () => {
        const mapOn = this.state.mapOn
        const collapsed = this.state.collapsed
        if (collapsed && mapOn) {
            console.log('something is wrong. This should never happen!!!')
        }
        if ((collapsed && !mapOn) || (!collapsed && mapOn)) {
            this.setState({
                mapOn: !mapOn,
                collapsed: !collapsed,
            })
        }
        if (!collapsed && !mapOn) {
            this.setState({
                mapOn: true,
            })
        }
    }

    showSettings = () => {
        const mapOn = this.state.mapOn
        const collapsed = this.state.collapsed
        if (collapsed && mapOn) {
            console.log('something is wrong. This should never happen!!!')
        }
        if ((collapsed && !mapOn) || (!collapsed && !mapOn)) {
            this.setState({
                collapsed: !collapsed,
            })
        }
        if (!collapsed && mapOn) {
            this.setState({
                mapOn: false,
            })
        }
    }

    onSelect = async (keys, event) => {
        const node = event.selectedNodes[0]
        const folderId = keys[0]
        const selectedFolder = findFolder(folderId, this.state.treeData)
        this.setState({
            selectedFolder: selectedFolder,
            folderPath: getFolderPath(this.state.treeData, folderId),
        });
        this.updateSettings(selectedFolder, null, this.state.settings.users);
        const photos = await photoService.getPhotos(keys[0])
        this.selectedFolderName = node.props.dataRef.text;
        this.setState({photos: photos})
    }

    onExpand = keys => {
        console.log('Trigger Expand', keys)
        this.setState({expandedKeys: keys})
    }

    handleRotation = async (event) => {
        if (this.state.selectedPhotos.length > 0) {
            const rotation = parseInt(event.key)
            const fileIds  = this.state.selectedPhotos.map(comp => {return comp.props.file._id})
            const rsp = await photoService.saveManyRotations(fileIds, rotation)
            if ( rsp.rspCode === 'ok') {
                for (let comp of this.state.selectedPhotos) {
                    const newRotation = rotation === 0 ? 0 : (comp.state.rotation + rotation) % 360
                    console.log("new rotation:", newRotation)
                    comp.setRotation(newRotation)

                }
                message.success("rotation saved successfully")
                //this.removeHighlight()
            }
            else{
                message.error("Error while saving rotation")
            }
        }
        else {
            message.error("Please select photos!")
        }
    }

    componentDidMount() {
        photoService
            .getTreeData()
            .then(data => {
                this.setState({
                    treeData: data,
                    selectedFolder: data[0],
                    expandedKeys: [data[0]._id],
                    loadingTree: false,
                });

                return userService.getUsers();
            })
            .then(users => {
                this.updateSettings(this.state.selectedFolder, null, users);
                searchHandler.setCurrentComponent(this);
            })
            .catch(error => {
                console.log(error)
            })
    }

    updateSettings = (folder, file, users) => {
        const folderLink = folder.publicLink
        const securityDetail = folder.securityDetail
        const selectedOwner = securityDetail ? securityDetail.owner : ''

        const selectedGuests = securityDetail
            ? _.map(securityDetail.guests, g => g.username)
            : []

        const iconColor = folder.stateColor
        let textStyle = []
        if (folder.textBoldStyle)
            textStyle.push(folder.textBoldStyle.value)
        if (folder.textItalicStyle)
            textStyle.push(folder.textItalicStyle.value)

        const textSize = folder.textSize ? folder.textSize.option : undefined
        const folderComments = folder.comments
        const fileComments = file ? file.comments : ''
        const fileLink = file ? file.publicLink : ''

        this.setState({
            settings: {
                selectedOwner: selectedOwner,
                selectedGuests: selectedGuests,
                users: users,
                folderLink: folderLink,
                iconColor: iconColor,
                textSize: textSize,
                textStyle: textStyle,
                file: file,
                fileComments: fileComments,
                fileLink: fileLink,
                folderComments: folderComments
            }
        });
    }

    saveShare = async (status) => {
        const fileIds = this.state.selectedPhotos.map(c => c.props.file._id);
        const rsp = await photoService.saveShared(fileIds, '' + status);
        if (rsp.rspCode == "ok") {
            this.state.selectedPhotos.forEach(c => c.setHighlight(false))
            this.state.selectedPhotos.forEach(c => {
                c.props.file.displayInSharedLink = '' + status;
                c.setShare(status)
            })
            this.state.selectedPhotos = []
            message.success('Shared status was saved successfully')
        }
        else {
            message.error("Error while saving")
        }

    }

    renderPhotoContainer = photos => {
        this.smallPhotos = {}
        const list = []
        for (let photo of photos) {
            let smallPhoto = (
                <SmallPhoto
                    key={photo._id}
                    file={photo}
                    onClick={this.handleOnSelectPhoto}
                    onDoubleClick={e => {
                        console.log('double clicking photo', e);

                        this.setState({carouselVisible: true})
                    }}
                    ref={e => {
                        this.smallPhotos[photo._id] = e
                    }}
                />
            )
            list.push(smallPhoto)
        }
        return list
    }

    renderBreadCrums = folderPath => {
        const paths = folderPath.split('/')
        return paths.map(p => {
            if (p.trim() !== '') {
                return <Breadcrumb.Item> {p}</Breadcrumb.Item>
            }
        })
    }

    render() {

        const owner = this.user.isFolderOwner(this.state.selectedFolder)
        const admin = this.user.hasRole(['Administrator']);
        const supervisor = this.user.hasRole(['Supervisor']);

        const menu = (
            <Menu>
                <Menu.Item key="90" onClick={this.handleRotation}>
                    <Icon type="redo"/>
                    90 degrees
                </Menu.Item>
                <Menu.Item key="180" onClick={this.handleRotation}>
                    <Icon type="redo"/>
                    180 degrees
                </Menu.Item>
                <Menu.Item key="270" onClick={this.handleRotation}>
                    <Icon type="redo"/>
                    270 degrees
                </Menu.Item>
                <Menu.Item key="0" onClick={this.handleRotation}>
                    <Icon type="redo"/>
                    reset
                </Menu.Item>
            </Menu>
        )

        const toolBarItems = [
            {
                title: 'rotate',
                icon: 'redo',
                type: 'dropdown-button',
                menu: menu,
                trigger: ['click'],
                display: admin || supervisor || owner
            },
            {
                title: 'share',
                icon: 'share-alt',
                onClick: () => this.saveShare(true),
                display: admin || supervisor || owner
            },
            {
                title: 'stop sharing',
                icon: 'stop',
                onClick: () => this.saveShare(false),
                display: admin || supervisor || owner
            },
            {
                title: 'show maps',
                icon: 'global',
                onClick: this.showMap,
                display: true
            },
            {
                title: 'cut',
                icon: 'scissor',
                onClick: () => {
                    this.cutPhotosIds = this.state.selectedPhotos.map(p => {
                        return p.props.file._id;
                    })
                },
                display: admin || owner
            },
            {
                title: 'paste',
                icon: 'snippets',
                onClick: () => {
                    this.moveFiles(this.cutPhotosIds, this.state.selectedFolder._id, false)
                    this.cutPhotosIds = []
                },
                display: admin || owner
            },
            {
                title: 'delete',
                icon: 'delete',
                onClick: this.handleDelete,
                display: admin || supervisor || owner
            },
            {
                title: 'download',
                icon: 'download',
                onClick: this.handleDownload,
                display: true
            },
            {
                title: 'settings',
                icon: 'setting',
                onClick: this.showSettings,
                display: admin || supervisor || owner
            },
        ]
        return (
            <div style={{flex: '1 1 auto', display: 'flex', flexDirection: 'column'}}>
                <input
                    type="file"
                    id="file"
                    ref={e => {
                        this.upload = e
                    }}
                    style={{display: 'none'}}
                    multiple
                    onChange={this.handleOnChangeFile}
                />
                <Row>
                    <Breadcrumb style={{margin: '16px 0'}}>
                        {this.renderBreadCrums(this.state.folderPath)}
                    </Breadcrumb>
                    <Divider style={{background: '#8080802e', margin: '0px 0px 17px 0px'}}/>
                </Row>
                <Row>
                    <Col span={12}>
                        <Row type="flex" justify="start">
                            <Search
                                onSearch={value => {
                                    this.setState(
                                        {
                                            searchString: value,
                                        },
                                    )
                                }}
                                style={{width: 330}}
                            />
                        </Row>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <Toolbar items={toolBarItems}/>
                        </Row>
                    </Col>
                    <Divider style={{background: 'transparent', margin: '5px 0px 12px 0px'}}/>
                </Row>

                <div id="photoContentPanel" style={{flex: 'auto', display: 'flex', flexDirection: 'column', overflow: 'auto', boxShadow: '0 1px 20px 0 rgba(69, 90, 100, .08)',}}>
                    <SplitterLayout primaryIndex={1} secondaryInitialSize={225}>
                        <Spin spinning={this.state.loadingTree} tip="Loading tree...">
                            <div style={{flex: 'auto', display: 'flex', flexDirection: 'column', height: '100px', overflowY: 'auto'}}>
                                <FolderTree
                                    onSelect={this.onSelect}
                                    onExpand={this.onExpand}
                                    selectedKeys={[this.state.selectedFolder._id]}
                                    expandedKeys={this.state.expandedKeys}
                                    treeData={this.state.treeData}
                                    onClickMenu={this.handleOnClickMenu}
                                    onMoveFiles={this.moveFiles}
                                    onMoveFolder={this.moveFolder}
                                    onLoadData={this.handleLoadData}
                                    permissions={this.state.selectedFolder.allowedActions}
                                />
                            </div>
                        </Spin>
                        <div
                            id="photoContainer"
                            style={{
                                flex: '1 1 auto',
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Layout>
                                <Content>
                                    <div
                                        onKeyDown={e => {
                                            this.ctrlKey = e.ctrlKey
                                        }}
                                        onKeyUp={e => {
                                            this.ctrlKey = e.ctrlKey
                                        }}
                                        tabIndex="0"
                                        style={{
                                            flex: '1 1 auto',
                                            overflow: 'auto',
                                            height: '100px',
                                            background: 'white',

                                        }}
                                    >
                                        {this.renderPhotoContainer(this.state.photos)}
                                    </div>
                                </Content>

                                <Sider
                                    trigger={null}
                                    collapsible
                                    collapsed={this.state.collapsed}
                                    style={{background: '#fff'}}
                                    width={460}
                                    collapsedWidth={0}
                                >
                                    <div style={{padding: '5px', height:'100px'}}>
                                        {!this.state.collapsed && this.state.mapOn ? (
                                            <Map
                                                photos={this.state.photos}
                                                folderId={this.state.selectedFolder._id}
                                                onClickOnMarker={this.handleOnClickOnMapMarker}
                                                ref={e => {
                                                    this.map = e
                                                }}
                                            />
                                        ) : !this.state.collapsed && !this.state.mapOn ? (
                                            <Settings
                                                data={this.state.settings}
                                                handler={this.settingsHandler}
                                                shareFolder={true}
                                                shareFile={false}
                                                authUser={this.user}
                                            />
                                        ) : null}
                                    </div>
                                </Sider>
                            </Layout>
                        </div>
                    </SplitterLayout>
                </div>
                <GenericModal
                    visible={this.state.modal.visible}
                    onOk={this.handleModalOk}
                    onCancel={this.closeModal}
                    data={this.state.modal.data}
                    action={this.state.modal.action}
                />
                <ModalCarousel
                    visible={this.state.carouselVisible}
                    photos={this.state.photos}
                    smallPhotos={this.smallPhotos}
                    initialSlide={this.getSelectedPhotoIndex()}
                    onCancel={() => {
                        this.setState({carouselVisible: false})
                    }}
                />
            </div>
        )
    }
    }

    export
    default
    PhotosView
